import { useEffect, useRef } from 'react';
import axios from 'axios';
import io from 'socket.io-client';
import useNotifications from '../store/notifications';
import useNotifySound from "../hooks/comptable/useNotifySound";

const SOCKET_SERVER_URL =
    process.env.REACT_APP_SOCKET_SERVER_URL || 'http://localhost:3001';

export default function NotificationsBoot() {
    const push = useNotifications((s) => s.push);
    const setAll = useNotifications((s) => s.setAll);
    const socketRef = useRef(null);
    const playNotify = useNotifySound();


    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) return;

        axios.get('/api/comptable/notifications?limit=50', {
                headers: { Authorization: `Bearer ${token}` },
            })
            .then((res) => setAll(res.data?.items || []))
            .catch(() => {});

        const socket = io(SOCKET_SERVER_URL, {
            withCredentials: true,
            transports: ['websocket', 'polling'],
        });
        socketRef.current = socket;

        const joinRoom = () => {
            try {
                const t = localStorage.getItem('token');
                if (!t) return;
                const payload = JSON.parse(atob(t.split('.')[1]));
                if (payload?.userId) {
                    socket.emit('join_room', String(payload.userId));
                }
            } catch (e) {
                console.warn('join_room failed:', e?.message || e);
            }
        };

        socket.on('connect', joinRoom);


        const onDone = (n) => {
            console.log('[NotificationsBoot] incoming notif:', n); // 👈 log serveur → client
            playNotify();  // 🔊 essaie de jouer
            push(n);
        };

        socket.on('tej:sync:done', onDone);

        // Nettoyage: enlever les listeners et fermer ce socket
        return () => {
            socket.off('tej:sync:done', onDone);
            socket.off('connect', joinRoom);
            socket.disconnect();
            socketRef.current = null;
        };
    }, [push, setAll]);

    return null;
}
